// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qSetReportContainer {
    background-color: #f2f2f2;
    margin-left: 15%;
    margin-right: 15%;
  }
  
  .qSetReportH3 {
    font-size: 24px;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
    margin-top: 70px;
    margin-bottom: 20px;
    color: #797979;
  }
  
  .qSetReportH3 .qSetReportArrow {
    font-size: 16px;
  }
    
    .qSetReportSearchButtonContainer {
      background: #ffffff;
      padding: 15px;
      margin-bottom: 15px;
      box-sizing: border-box;
      color: #797979;
      font-family: "Ruda", sans-serif;
      font-size: 13px;
      box-shadow: 3px 3px 3px 3px #aab2bd;
      margin-left: 15%;
      margin-right: 15%;
    }
    
    .qSetReportSearchBtn {
      color: #fff;
      background-color: #68dff0;
      box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
      padding: 6px 12px;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.42857143;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      border: 1px solid #48bcb4;
      border-radius: 4px;
      cursor: pointer;
    }
    .qSetReportSearchBtn:hover {
      background-color: #51cac2;
    }
    
    .qSetReportSearchBtn:active {
      background-color: #327e79;
    }
    
    .qSetReportSearchContainer {
      background: #ffffff;
      padding: 15px;
      margin-bottom: 15px;
      box-sizing: border-box;
      color: #797979;
      font-family: "Ruda", sans-serif;
      font-size: 13px;
      box-shadow: 3px 3px 3px 3px #aab2bd;
      margin-left: 15%;
      margin-right: 15%;
    }
    
    .qSetReportHeading {
      font-size: 18px;
      margin-top: 10px;
      margin-bottom: 10px;
      font-family: "Ruda", sans-serif;
      font-weight: 500;
      line-height: 1.1;
      color: inherit;
    }
    
    
    .qSetReportLabel {
      font-size: 16px;
      margin-top: 8px;
      margin-bottom: 5px;
      font-weight: 500;
      margin-right: 3%;
      width: 20%;
      margin-left: 9%;
      color: #797979;
      font-family: "Ruda", sans-serif;
    }
    
    .qSetReportSelect {
      box-sizing: border-box;
      width: 52%;
      position: relative;
      max-height: 35px;
      padding-right: 15px;
      padding-left: 15px;
      color: #555;
      font-family: "Ruda", sans-serif;
      font-size: 13px;
      line-height: 1.42857143;
      margin-left: 4%;
      margin-right: 11%;
      border-radius: 4px;
      border: 1px solid #ccc;
      outline-color: #68dff0;
      transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    }
    
    .qSetReportDropdownDiv {
      display: flex;
      margin-bottom: 20px;
    }
    
    .qSetReportloadingDiv {
      display: inline-flex;
      height: 30px;
      width: 290px;
      position: absolute;
    }
  
    .qSetRepReactLoadingIcon {
      height: 25px !important;
      margin-left: 10px;
      width: 30px !important;
      margin-right: 18px;
    }
    
    .qSetRepLoadingTextData {
      color: #797979;
      font-family: "Ruda", sans-serif;
      font-size: 16px;
      margin-top: 8px;
      margin-bottom: 5px;
      font-weight: 500;
      margin-right: 4%;
      width: 180px;
      margin-left: 20px;
    }

    .topRepCheckDiv {
      width: 100%;
      margin-bottom: 20px;
    }

    .topRepdropdown {
      display: flex;
      width: 100%;
      margin-bottom: 20px;
    }

    .topRepDropdownLabel {
      font-size: 16px;
      margin-top: 8px;
      margin-bottom: 5px;
      font-weight: 500;
      margin-right: 3%;
      width: 20%;
      margin-left: 9%;
      color: #797979;
      font-family: "Ruda", sans-serif;
    }

    .qSetReportCheckbox {
      height: 22px;
      width: 3.2%;
      box-sizing: border-box;
      position: relative;
      max-height: 35px;
      margin-left: 4%;
      margin-right: 11%;
    }
    
    `, "",{"version":3,"sources":["webpack://./src/components/Screens/QSetReport/QSetReportComponents/QSetReportSearch/qSetReportSearch.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;IAEE;MACE,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,sBAAsB;MACtB,cAAc;MACd,+BAA+B;MAC/B,eAAe;MACf,mCAAmC;MACnC,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,yBAAyB;MACzB,4CAA4C;MAC5C,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,mBAAmB;MACnB,sBAAsB;MACtB,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;IACjB;IACA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,sBAAsB;MACtB,cAAc;MACd,+BAA+B;MAC/B,eAAe;MACf,mCAAmC;MACnC,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,+BAA+B;MAC/B,gBAAgB;MAChB,gBAAgB;MAChB,cAAc;IAChB;;;IAGA;MACE,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,UAAU;MACV,eAAe;MACf,cAAc;MACd,+BAA+B;IACjC;;IAEA;MACE,sBAAsB;MACtB,UAAU;MACV,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,WAAW;MACX,+BAA+B;MAC/B,eAAe;MACf,uBAAuB;MACvB,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,sBAAsB;MACtB,sBAAsB;MACtB,wEAAwE;IAC1E;;IAEA;MACE,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,oBAAoB;MACpB,YAAY;MACZ,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,uBAAuB;MACvB,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,+BAA+B;MAC/B,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,UAAU;MACV,eAAe;MACf,cAAc;MACd,+BAA+B;IACjC;;IAEA;MACE,YAAY;MACZ,WAAW;MACX,sBAAsB;MACtB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;IACnB","sourcesContent":[".qSetReportContainer {\n    background-color: #f2f2f2;\n    margin-left: 15%;\n    margin-right: 15%;\n  }\n  \n  .qSetReportH3 {\n    font-size: 24px;\n    font-family: inherit;\n    font-weight: 500;\n    line-height: 1.1;\n    color: inherit;\n    margin-top: 70px;\n    margin-bottom: 20px;\n    color: #797979;\n  }\n  \n  .qSetReportH3 .qSetReportArrow {\n    font-size: 16px;\n  }\n    \n    .qSetReportSearchButtonContainer {\n      background: #ffffff;\n      padding: 15px;\n      margin-bottom: 15px;\n      box-sizing: border-box;\n      color: #797979;\n      font-family: \"Ruda\", sans-serif;\n      font-size: 13px;\n      box-shadow: 3px 3px 3px 3px #aab2bd;\n      margin-left: 15%;\n      margin-right: 15%;\n    }\n    \n    .qSetReportSearchBtn {\n      color: #fff;\n      background-color: #68dff0;\n      box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n      padding: 6px 12px;\n      margin-bottom: 0;\n      font-size: 14px;\n      font-weight: normal;\n      line-height: 1.42857143;\n      text-align: center;\n      white-space: nowrap;\n      vertical-align: middle;\n      border: 1px solid #48bcb4;\n      border-radius: 4px;\n      cursor: pointer;\n    }\n    .qSetReportSearchBtn:hover {\n      background-color: #51cac2;\n    }\n    \n    .qSetReportSearchBtn:active {\n      background-color: #327e79;\n    }\n    \n    .qSetReportSearchContainer {\n      background: #ffffff;\n      padding: 15px;\n      margin-bottom: 15px;\n      box-sizing: border-box;\n      color: #797979;\n      font-family: \"Ruda\", sans-serif;\n      font-size: 13px;\n      box-shadow: 3px 3px 3px 3px #aab2bd;\n      margin-left: 15%;\n      margin-right: 15%;\n    }\n    \n    .qSetReportHeading {\n      font-size: 18px;\n      margin-top: 10px;\n      margin-bottom: 10px;\n      font-family: \"Ruda\", sans-serif;\n      font-weight: 500;\n      line-height: 1.1;\n      color: inherit;\n    }\n    \n    \n    .qSetReportLabel {\n      font-size: 16px;\n      margin-top: 8px;\n      margin-bottom: 5px;\n      font-weight: 500;\n      margin-right: 3%;\n      width: 20%;\n      margin-left: 9%;\n      color: #797979;\n      font-family: \"Ruda\", sans-serif;\n    }\n    \n    .qSetReportSelect {\n      box-sizing: border-box;\n      width: 52%;\n      position: relative;\n      max-height: 35px;\n      padding-right: 15px;\n      padding-left: 15px;\n      color: #555;\n      font-family: \"Ruda\", sans-serif;\n      font-size: 13px;\n      line-height: 1.42857143;\n      margin-left: 4%;\n      margin-right: 11%;\n      border-radius: 4px;\n      border: 1px solid #ccc;\n      outline-color: #68dff0;\n      transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n    }\n    \n    .qSetReportDropdownDiv {\n      display: flex;\n      margin-bottom: 20px;\n    }\n    \n    .qSetReportloadingDiv {\n      display: inline-flex;\n      height: 30px;\n      width: 290px;\n      position: absolute;\n    }\n  \n    .qSetRepReactLoadingIcon {\n      height: 25px !important;\n      margin-left: 10px;\n      width: 30px !important;\n      margin-right: 18px;\n    }\n    \n    .qSetRepLoadingTextData {\n      color: #797979;\n      font-family: \"Ruda\", sans-serif;\n      font-size: 16px;\n      margin-top: 8px;\n      margin-bottom: 5px;\n      font-weight: 500;\n      margin-right: 4%;\n      width: 180px;\n      margin-left: 20px;\n    }\n\n    .topRepCheckDiv {\n      width: 100%;\n      margin-bottom: 20px;\n    }\n\n    .topRepdropdown {\n      display: flex;\n      width: 100%;\n      margin-bottom: 20px;\n    }\n\n    .topRepDropdownLabel {\n      font-size: 16px;\n      margin-top: 8px;\n      margin-bottom: 5px;\n      font-weight: 500;\n      margin-right: 3%;\n      width: 20%;\n      margin-left: 9%;\n      color: #797979;\n      font-family: \"Ruda\", sans-serif;\n    }\n\n    .qSetReportCheckbox {\n      height: 22px;\n      width: 3.2%;\n      box-sizing: border-box;\n      position: relative;\n      max-height: 35px;\n      margin-left: 4%;\n      margin-right: 11%;\n    }\n    \n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
